import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6501Model } from './kymw6501.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { OrderCodeTextInputComponent } from './../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CwsPlanCategoryCodeComboBoxComponent } from './../../../commons/kymw02/combo-box/cws-plan-category-code-combo-box/cws-plan-category-code-combo-box.component';
import { NotNullTextInputComponent } from '../../../commons/kymw02/not-null-text-input/not-null-text-input.component';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { GetCwsTimeSaleInfoService } from './api-services/get-cws-time-sale-info.service';
import { RegistCwsTimeSaleInfoService } from './api-services/regist-cws-time-sale-info.service';
import { UpdateCwsTimeSaleInfoService } from './api-services/update-cws-time-sale-info.service';
import { DeleteCwsTimeSaleInfoService } from './api-services/delete-cws-time-sale-info.service';
import { NotNullTextAreaComponent } from '../../../commons/kymw02/not-null-text-area/not-null-text-area.component';
import { KYMW6501InputModel } from './vo/kymw6501-input.model';
import { TimeSaleDataModel } from './vo/time-sale-data.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { CommonSetting } from '../../../commons/kymw00/common-setting';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';

/**
 * ECタイムセールマスタ設定画面を管理するクラス
 *
 * @export KYMW6501Component
 * @class KYMW6501Component
 */
@Component({
  selector: 'app-kymw6501',
  templateUrl: 'kymw6501.component.html',
  styleUrls: ['kymw6501.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6501Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw6501Model: KYMW6501Model = new KYMW6501Model();

  public inputVo: KYMW6501InputModel = null;

  isComposing = false;

  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;
  @ViewChild('btn_Update', { static: true }) btn_Update: ElementRef;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_CategoryCode', { static: true }) cmb_CategoryCode: CwsPlanCategoryCodeComboBoxComponent;
  @ViewChild('txta_BannerFileBB_BF', { static: true }) txta_BannerFileBB_BF: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileBB_ON', { static: true }) txta_BannerFileBB_ON: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileBB_AF', { static: true }) txta_BannerFileBB_AF: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileMB_BF', { static: true }) txta_BannerFileMB_BF: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileMB_ON', { static: true }) txta_BannerFileMB_ON: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileMB_AF', { static: true }) txta_BannerFileMB_AF: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileSP_BF', { static: true }) txta_BannerFileSP_BF: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileSP_ON', { static: true }) txta_BannerFileSP_ON: NotNullTextAreaComponent;
  @ViewChild('txta_BannerFileSP_AF', { static: true }) txta_BannerFileSP_AF: NotNullTextAreaComponent;
  @ViewChild('txta_BannerCaptionBB_BF', { static: true }) txta_BannerCaptionBB_BF: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionBB_ON', { static: true }) txta_BannerCaptionBB_ON: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionBB_AF', { static: true }) txta_BannerCaptionBB_AF: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionMB_BF', { static: true }) txta_BannerCaptionMB_BF: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionMB_ON', { static: true }) txta_BannerCaptionMB_ON: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionMB_AF', { static: true }) txta_BannerCaptionMB_AF: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionSP_BF', { static: true }) txta_BannerCaptionSP_BF: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionSP_ON', { static: true }) txta_BannerCaptionSP_ON: NotNullTextInputComponent;
  @ViewChild('txta_BannerCaptionSP_AF', { static: true }) txta_BannerCaptionSP_AF: NotNullTextInputComponent;
  @ViewChild('dtf_StartDate', { static: true }) dtf_StartDate: WjInputDate;
  @ViewChild('cmb_StartHour', { static: true }) cmb_StartHour: ElementRef;
  @ViewChild('cmb_StartMinute', { static: true }) cmb_StartMinute: ElementRef;
  @ViewChild('dtf_EndDate', { static: true }) dtf_EndDate: WjInputDate;
  @ViewChild('cmb_EndHour', { static: true }) cmb_EndHour: ElementRef;
  @ViewChild('cmb_EndMinute', { static: true }) cmb_EndMinute: ElementRef;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW6501Model;

  /**
   *Creates an instance of KYMW6501Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW6501Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private registCwsTimeSaleInfoService: RegistCwsTimeSaleInfoService,
    private getCwsTimeSaleInfoService: GetCwsTimeSaleInfoService,
    private updateCwsTimeSaleInfoService: UpdateCwsTimeSaleInfoService,
    private deleteCwsTimeSaleInfoService: DeleteCwsTimeSaleInfoService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6501';
    this.kymw6501Model.kymw6501Component = this;
    this.List();
    this.createHourList();
    this.createMinList();

    setTimeout(() => {
      // デフォルトフォーカス設定
      this.eventListenerSetting();
      this.plessEnabledSetting();
    });
  }

  // 活性・非活性制御処理
  public plessEnabledSetting() {

    // 処理区分のチェック
    if (this.kymw6501Model.procesDiv === TimeSaleDataModel.PROCES_DIV_REGIST) { // 「1:登録」の場合
      // 初期表示時の活性・非活性制御
      this.plessEnabled(this.txti_OrderCode, true);                             // 受注コード
      this.plessEnabled(this.cmb_CategoryCode, true);                           // カテゴリコード
      this.plessEnabled(this.btn_Delete, false);                                // 削除ボタン
      this.plessEnabled(this.btn_Update, true);                                 // 更新ボタン

      // デフォルト値の設定
      this.kymw6501Model.bannerFileNameBfBB = CommonSetting.getVal('TimeSaleBannerFileNameBF_BB');
      this.kymw6501Model.bannerFileNameOnBB = CommonSetting.getVal('TimeSaleBannerFileNameON_BB');
      this.kymw6501Model.bannerFileNameAfBB = CommonSetting.getVal('TimeSaleBannerFileNameAF_BB');
      this.kymw6501Model.bannerFileNameBfMB = CommonSetting.getVal('TimeSaleBannerFileNameBF_MB');
      this.kymw6501Model.bannerFileNameOnMB = CommonSetting.getVal('TimeSaleBannerFileNameON_MB');
      this.kymw6501Model.bannerFileNameAfMB = CommonSetting.getVal('TimeSaleBannerFileNameAF_MB');
      this.kymw6501Model.bannerFileNameBfSP = CommonSetting.getVal('TimeSaleBannerFileNameBF_SP');
      this.kymw6501Model.bannerFileNameOnSP = CommonSetting.getVal('TimeSaleBannerFileNameON_SP');
      this.kymw6501Model.bannerFileNameAfSP = CommonSetting.getVal('TimeSaleBannerFileNameAF_SP');

      this.kymw6501Model.bannerCaptionBfBB = CommonSetting.getVal('TimeSaleBannerCaptionBF_BB');
      this.kymw6501Model.bannerCaptionOnBB = CommonSetting.getVal('TimeSaleBannerCaptionON_BB');
      this.kymw6501Model.bannerCaptionAfBB = CommonSetting.getVal('TimeSaleBannerCaptionAF_BB');
      this.kymw6501Model.bannerCaptionBfMB = CommonSetting.getVal('TimeSaleBannerCaptionBF_MB');
      this.kymw6501Model.bannerCaptionOnMB = CommonSetting.getVal('TimeSaleBannerCaptionON_MB');
      this.kymw6501Model.bannerCaptionAfMB = CommonSetting.getVal('TimeSaleBannerCaptionAF_MB');

      this.kymw6501Model.bannerCaptionBfSP = CommonSetting.getVal('TimeSaleBannerCaptionBF_SP');
      this.kymw6501Model.bannerCaptionOnSP = CommonSetting.getVal('TimeSaleBannerCaptionON_SP');
      this.kymw6501Model.bannerCaptionAfSP = CommonSetting.getVal('TimeSaleBannerCaptionAF_SP');

      // デフォルトフォーカス設定
      this.txti_OrderCode.setFocus();

    } else {                                                                    // 「1:登録」以外の場合

      // 初期表示時の活性・非活性制御
      this.plessEnabled(this.txti_OrderCode, false);                            // 受注コード
      this.plessEnabled(this.cmb_CategoryCode, false);                          // カテゴリコード
      this.plessEnabled(this.btn_Delete, true);                                 // 削除ボタン
      this.plessEnabled(this.btn_Update, true);                                 // 更新ボタン

      // コンボボックス生成
      this.cmb_CategoryCode.selectedOrderCode = this.inputVo.OrderCode;
      this.cmb_CategoryCode.stockLimitFlg = '1';
      this.cmb_CategoryCode.categoryLevel = 1;
      this.cmb_CategoryCode.updateCategoryList();
      this.cmb_CategoryCode.setCategoryCode(this.inputVo.CategoryCode);

      // 登録商品情報取得処理
      const vo: TimeSaleDataModel = this.kymw6501Model.getTimeSaleDataVo();

      // データ取得
      this.getCwsTimeSaleInfoService.execute(this.kymw6501Model, vo, () => {
      // デフォルトフォーカス設定
      this.dtf_StartDate.focus();
      });
    }
  }

  public eventListenerSetting() {
    /**
     * 編集済みチェック用に、イベントを割り当て
     */
    const changeObj: Array<any> = [
      'txti_OrderCode', 'cmb_CategoryCode',
      'dtf_StartDate', 'cmb_StartHour', 'cmb_StartMinute',
      'dtf_EndDate', 'cmb_EndHour', 'cmb_EndMinute',
      'txta_BannerFileBB_BF', 'txta_BannerCaptionBB_BF',
      'txta_BannerFileBB_ON', 'txta_BannerCaptionBB_ON',
      'txta_BannerFileBB_AF', 'txta_BannerCaptionBB_AF',
      'txta_BannerFileMB_BF', 'txta_BannerCaptionMB_BF',
      'txta_BannerFileMB_ON', 'txta_BannerCaptionMB_ON',
      'txta_BannerFileMB_AF', 'txta_BannerCaptionMB_AF',
      'txta_BannerFileSP_BF', 'txta_BannerCaptionSP_BF',
      'txta_BannerFileSP_ON', 'txta_BannerCaptionSP_ON',
      'txta_BannerFileSP_AF', 'txta_BannerCaptionSP_AF'
    ];

    for (let i = Number(0); i < changeObj.length; i++) {
      document.getElementById(changeObj[i]).addEventListener('change', () => this.eventEditHandler());
    }
  }

  /**
   *  親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW6501Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVo = <KYMW6501InputModel>param;
    this.kymw6501Model.procesDiv = this.inputVo.ProcesDiv;
    this.kymw6501Model.orderCode = this.inputVo.OrderCode;
    this.kymw6501Model.categoryCode = this.inputVo.CategoryCode;
  }

  /**
   * コンボボックスのリストに中身を入れる
   *
   * @memberof KYMW6501Component
   */
  public List() {
    this.kymw6501Model.startHourList = this.createHourList();
    this.kymw6501Model.startMinuteList = this.createMinList();
    this.kymw6501Model.endHourList = this.createHourList();
    this.kymw6501Model.endMinuteList = this.createMinList();
  }

  /**
   * コンボボックスの中身を生成
   *
   * @returns {Array<any>}
   * @memberof KYMW6501Component
   */
  public createHourList(): Array<any> {
    const list: Array<any> = [];

    for (let i = Number(0); i < 24; i++) {
      list.push(PlessViewUtilsSub.zeroPadding(2, i.toString()));
    }
    return list;
  }
  public createMinList(): Array<any> {
    const list: Array<any> = [];

    for (let i = Number(0); i < 60; i++) {
      list.push(PlessViewUtilsSub.zeroPadding(2, i.toString()));
    }
    return list;
  }

  /**
   * 「受注コード」変更イベント処理
   *
   * @memberof KYMW6501Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    // 受注コードのチェック
    if (!PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {    // 入力完了の場合
      this.cmb_CategoryCode.initFocusItem = this.txti_OrderCode;
      this.cmb_CategoryCode.selectedOrderCode = this.kymw6501Model.orderCode;
      this.cmb_CategoryCode.stockLimitFlg = '1';
      this.cmb_CategoryCode.categoryLevel = 1;
      this.cmb_CategoryCode.updateCategoryList();
    } else {                                                                    // 入力未完了の場合
      this.cmb_CategoryCode.clear();
    }
  }

  /**
   * 「更新」ボタンイベント
   *
   * @returns {void}
   * @memberof KYMW6501Component
   */
  public eventUpdate_CLICKHandler(): void {
    const orderCode = Number(this.kymw6501Model.orderCode);

    // 編集有無の確認
    if (!this.kymw6501Model.isEdited) {
      this.dialogService.openAlertGetMessage('E0162');
      return;
    }

    // 必須項目のチェック
    // 受注コード
    if (PlessViewUtilsSub.isEmpty(this.kymw6501Model.orderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
      return;
    }

    // カテゴリコード
    if (PlessViewUtilsSub.isEmpty(this.kymw6501Model.categoryCode)) {
      this.dialogService.openAlertGetMessage('E0103', ['カテゴリ']);
      return;
    }

    // 開催期間(From)
    if (PlessViewUtilsSub.isEmpty(this.dtf_StartDate.text)) {
      this.dialogService.openAlertGetMessage('E0148', ['開催期間From']);
      return;
    }

    // 開催期間(To)
    if (PlessViewUtilsSub.isEmpty(this.dtf_EndDate.text)) {
      this.dialogService.openAlertGetMessage('E0148', ['開催期間To']);
      return;
    }

    // 開催前バナーキャプション(BB)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionBB_BF.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催前バナーキャプション(BB)']);
      return;
    }

    // 開催中バナーキャプション(BB)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionBB_ON.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催中バナーキャプション(BB)']);
      return;
    }

    // 開催後バナーキャプション(BB)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionBB_AF.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催後バナーキャプション(BB)']);
      return;
    }

    // 開催前バナーキャプション(MB)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionMB_BF.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催前バナーキャプション(MB)']);
      return;
    }

    // 開催中バナーキャプション(MB)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionMB_ON.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催中バナーキャプション(MB)']);
      return;
    }

    // 開催後バナーキャプション(MB)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionMB_AF.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催後バナーキャプション(MB)']);
      return;
    }

    // 開催前バナーキャプション(SP)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionSP_BF.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催前バナーキャプション(SP)']);
      return;
    }

    // 開催中バナーキャプション(SP)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionSP_ON.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催中バナーキャプション(SP)']);
      return;
    }

    // 開催後バナーキャプション(SP)
    if (PlessViewUtilsSub.isEmpty(this.txta_BannerCaptionSP_AF.text)) {
      this.dialogService.openAlertGetMessage('E0110', ['開催後バナーキャプション(SP)']);
      return;
    }

    // 開始日時と終了日時の大小チェック
    const startDate: Date = this.dtf_StartDate.value;
    const endDate: Date = this.dtf_EndDate.value;

    startDate.setHours(Number(this.kymw6501Model.startDateHH));
    startDate.setMinutes(Number(this.kymw6501Model.startDateMI));
    endDate.setHours(Number(this.kymw6501Model.endDateHH));
    endDate.setMinutes(Number(this.kymw6501Model.endDateMI));

    if (startDate >= endDate) {
      this.dialogService.openAlertGetMessage('E0253', ['終了日時', '開始日時']);
      return;
    }

    // 確認フラグのリセット
    this.kymw6501Model.confirmFlg = '0';

    // 処理区分のチェック
    if (this.kymw6501Model.procesDiv === TimeSaleDataModel.PROCES_DIV_REGIST) {
      // メッセージを表示
      this.dialogService.openAlertGetMessage('Q0104', ['タイムセールマスタ情報'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.dispatcherKYMW6501RegistEvent();
          }
        }
      );
    } else {
      // メッセージを表示
      this.dialogService.openAlertGetMessage('Q0105', ['タイムセールマスタ情報'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.dispatcherKYMW6501UpdateEvent();
          }
        }
      );
    }
  }

  /**
   * 登録イベント発行
   *
   * @memberof KYMW6501Component
   */
  public dispatcherKYMW6501RegistEvent(): void {
    const vo: TimeSaleDataModel = this.kymw6501Model.getTimeSaleDataVo();
    /** データ取得 */
    this.registCwsTimeSaleInfoService.execute(this.kymw6501Model, vo);
  }

  /**
   * 登録完了後処理
   *
   * @param {*} serverData
   * @returns {void}
   * @memberof KYMW6501Component
   */
  public registSuccess(serverData: any): void {
    // 業務警告の場合は確認メッセージを表示する
    if (serverData != null && !PlessViewUtilsSub.isEmpty(serverData.MessageId)) {
      this.dialogService.openAlertGetMessage(serverData.MessageId, [serverData.Arg1, serverData.Arg2],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            // YESの場合、確認フラグを更新して再度リクエストを送信する
            this.kymw6501Model.confirmFlg = serverData.ConfirmFlg;
            this.dispatcherKYMW6501RegistEvent();
          }
        }
      );
      return;
    }

    // 正常終了時は画面を閉じる
    this.kymw6501Model.isEdited = false;
    this.closeFunction();
  }

  /**
   * 更新イベント発行
   *
   * @memberof KYMW6501Component
   */
  public dispatcherKYMW6501UpdateEvent(): void {
    const vo: TimeSaleDataModel = this.kymw6501Model.getTimeSaleDataVo();
    // データ取得
    this.updateCwsTimeSaleInfoService.execute(this.kymw6501Model, vo);
  }

  /**
   * 更新完了後処理
   *
   * @param {*} serverData
   * @returns {void}
   * @memberof KYMW6501Component
   */
  public updateSuccess(serverData: any): void {
    // 業務警告の場合は確認メッセージを表示する
    if (serverData != null && !PlessViewUtilsSub.isEmpty(serverData.MessageId)) {
      this.dialogService.openAlertGetMessage(serverData.MessageId, [serverData.Arg1, serverData.Arg2],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            // YESの場合、確認フラグを更新して再度リクエストを送信する
            this.kymw6501Model.confirmFlg = serverData.ConfirmFlg;
            this.dispatcherKYMW6501UpdateEvent();
          }
        }
      );
      return;
    }

    // 正常終了時は画面を閉じる
    this.kymw6501Model.isEdited = false;
    this.closeFunction();
  }

  /**
   * 「削除」ボタンイベント
   *
   * @returns {void}
   * @memberof KYMW6501Component
   */
  public eventDelete_CLICKHandler(): void {
    // 必須項目のチェック
    // カテゴリコード
    if (PlessViewUtilsSub.isEmpty(this.cmb_CategoryCode.selectedCategoryCode)) {
      this.dialogService.openAlertGetMessage('E0103', ['カテゴリ']);
      return;
    }

    // メッセージを表示
    this.dialogService.openAlertGetMessage('Q0106', ['タイムセールマスタ情報'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.dispatcherKYMW6501DeleteEvent();
        }
      }
    );
  }

  /**
   * 削除イベント発行
   *
   * @memberof KYMW6501Component
   */
  public dispatcherKYMW6501DeleteEvent(): void {
    const vo: TimeSaleDataModel = this.kymw6501Model.getTimeSaleDataVo();
    // データ取得
    this.deleteCwsTimeSaleInfoService.execute(this.kymw6501Model, vo);
  }

  /**
   * 削除完了後処理
   *
   * @memberof KYMW6501Component
   */
  public deleteSuccess(): void {
    // 正常終了時は画面を閉じる
    this.kymw6501Model.isEdited = false;
    this.closeFunction();
  }

  /**
   * 閉じるボタンクリックイベント
   *
   * @memberof KYMW6501Component
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.kymw6501Model.isEdited) {
      this.dialogService.openAlertGetMessage('Q0107', ['タイムセールマスタ情報'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.closeFunction();
          }
        }
      );
    } else {
      this.closeFunction();
    }
  }

  /**
   * 項目変更時イベント
   *
   * @memberof KYMW6501Component
   */
  public eventEditHandler(): void {
    this.kymw6501Model.isEdited = true;
  }

  /**
   * デフォルトフォーカス設定
   *
   * @memberof KYMW6501Component
   */
  public initFocus(): void {
    // 処理区分のチェック
    if (this.kymw6501Model.procesDiv === TimeSaleDataModel.PROCES_DIV_REGIST) { // 「1:登録」の場合
      // デフォルトフォーカス設定
      this.txti_OrderCode.setFocus();
    } else {                                                                    // 「1:登録」以外の場合
      // デフォルトフォーカス設定
      this.dtf_StartDate.focus();
    }
  }

  /**
   * バナーファイル名の入力から半角カンマを削除
   * @param idStr idの下５文字（XX_XXの形）
   * @param modelStr modelの下４文字（XxXXの形）
   */
  public eventBannerFile_deleteCommaHandler(idStr: string, modelStr: string): void {
    // 入力された値から半角カンマを削除
    const str = this[`txta_BannerFile${idStr}`].text.replace(/,/g, '');
    // model変更・画面に反映
    this.kymw6501Model[`bannerFileName${modelStr}`] = str;
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }
}
